<script lang="ts" setup>
import { useRouter } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";

const router = useRouter();
const toMypageSubscribeNewsletter = { name: "MypageSubscribeNewsletter" };
const toMypageReceivePushNotification = {
  name: "MypageReceivePushNotification"
};

function onClickBack() {
  router.back();
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      メール・プッシュ通知受信設定
    </Header>
    <div class="mypage py-3">
      <div class="section px-3 pt-4 mt-2">
        <div class="bg-white border border-outline-color px-3 mt-1 round-4">
          <RouterLink
            :to="toMypageSubscribeNewsletter"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">メール</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="toMypageReceivePushNotification"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">プッシュ通知</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mypage {
  position: relative;

  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}
</style>
